import ElasticProcessor from '@lib/processors/elastic-processor'
import isPast from '@lib/utils/date-is-past'

const TABLE_FILTERS = [
  {
    attribute: 'createdAt',
    label: 'Date Created',
    type: 'date',
    icon: 'el-icon-date',
    dateOptions: {
      disabledDate(date) {
        return !isPast(date)
      },
    },
  },
  {
    attribute: 'name',
    label: 'Provider Name',
    type: 'string',
    icon: 'el-icon-notebook-2',
  },
  {
    attribute: 'updatedAt',
    label: 'Last Updated',
    icon: 'el-icon-date',
    type: 'date',
  },
  {
    attribute: 'active',
    label: 'Status',
    icon: 'el-icon-circle-check',
    type: 'select',
    values: [
      {
        label: 'Active',
        value: true,
      },
      {
        label: 'Inactive',
        value: false,
      },
    ],
  },
]

const TABLE_COLUMNS = [
  {
    name: 'createdAt',
    label: 'Date Created',
    format: 'dateTime',
    icon: 'el-icon-date',
    width: 140,
  },
  {
    name: 'name',
    label: 'Provider Name',
    icon: 'el-icon-notebook-2',
    elasticSubField: 'lowercase',
  },
  {
    name: 'updatedAt',
    label: 'Last Updated',
    format: 'dateTime',
    icon: 'el-icon-date',
    width: 140,
  },
  {
    name: 'active',
    icon: 'el-icon-circle-check',
    label: 'Status',
    format: 'capital',
    width: 90,
    component: {
      props: {
        styleObj(_, row) {
          return row.active ? { color: '#29d737' } : { color: '#fc1e1e' }
        },
        badge(_, row) {
          return row.active ? { name: 'el-icon-check', pos: 'left' } : { name: 'el-icon-close', pos: 'left' }
        },
        value(_, row) {
          return row.active ? 'active' : 'inactive'
        },
      },
    },
  },
]

export default component => ({
  processor: new ElasticProcessor({
    component,
    index: 'providers',
    initialDataQuery: {
      defaultSort: {
        'name.lowercase': 'asc',
      },
    },
  }),
  filters: TABLE_FILTERS,
  columns: TABLE_COLUMNS,
  tableName: 'providers',
})
